import { localeData as uiLocaleData } from '@games/ui';
import siteLocaleData from "./localeData";

export const localeData: Record<string, Record<string, string>> = {};

for (const lang of Object.keys(siteLocaleData)) {
  localeData[lang] = {
    ...siteLocaleData[lang as keyof typeof siteLocaleData],
    ...(uiLocaleData[lang as keyof typeof uiLocaleData] || {}),
  };
}
